import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class SalesGroupService {
  private apiUrl = '/salesgroups';
  private apiSpringUrl = '/spring/salesgroups';
  private apiPlayUrl = '/play/salesgroups';

  constructor(private http: HttpService) { }

  get(query?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    return this.http.get(url, query);
  }

  post(
    salesgroupCd: string,
    salesgroupTx: string,
    salescategoryId: number,
    salesgroupunitTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    const jsonInput = {
      salesgroupCd: salesgroupCd,
      salesgroupTx: salesgroupTx,
      salescategoryId: salescategoryId,
      salesgroupunitTx: salesgroupunitTx,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  put(
    salesgroupId: number,
    salesgroupCd: string,
    salesgroupTx: string,
    salescategoryId: number,
    salesgroupunitTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${salesgroupId}`;
    const jsonInput = {
      salesgroupCd: salesgroupCd,
      salesgroupTx: salesgroupTx,
      salescategoryId: salescategoryId,
      salesgroupunitTx: salesgroupunitTx,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(salesgroupId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${salesgroupId}`;
    return this.http.delete(url);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/sales-group/sales-group.service.ts